import React from 'react';

function Certificate({ name, counter, onClick }) {
  const today = new Date();
  const month = today.getMonth() + 1;
  return (
    <div className="certificateContent answerContent">
      <div className="certificateWrapper">
        <div className="certificateInner">
          <p className="certificateCounter">No.{('00000' + counter).slice(-5)}</p>
          <p className="resultStamp">
            <img src={'assets/img/stamp-result-04.png'} alt="たいへんよくできました" className="stampResult" />
          </p>
          <p className="certificateTitle">
            <img src={'assets/img/ttl-certificate.png'} alt="表彰状" className="ttlCertificate" />
          </p>
          <div className="nameRow">
            <p className="certificateName">{name}</p>
            <p>
              <img src={'assets/img/txt-sama.png'} alt="さま" className="txtSama" />
            </p>
          </div>
          <p className="certificateText">
            <img src={'assets/img/txt-certificate-01.png'} alt="おめでとうございます!!植物ふしぎ検定満点です!!" className="txtCertificate" />
          </p>
          <p className="certificateText2">
            <img src={'assets/img/txt-certificate-02.png'} alt="このページをスクリーンショットしてグリーンセンターに持っていくと特典がもらえるよ!" className="txtCertificate2" />
          </p>
          <p className="certificateDate">{today.getFullYear() + '年' + month + '月' + today.getDate() + '日'}</p>
          <p className="certificateNote">※発行日に限り有効</p>
        </div>
        <div className="certificateUsage">
          <img src={'assets/img/usage-certificate.png'} alt="【ご利用について】必ずお読みください。この画面をスクリーンショットもしくは印刷してご利用ください。ご利用は１回限りです。転載や譲渡は禁止です。ただし、家族間でのご利用は可能です。" className="txtUsage" />
        </div>
      </div>
    </div>
  );
}

export default Certificate;
